exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".slidedown-enter-active,.slidedown-leave-active{max-height:30rem;opacity:1;overflow:hidden;-webkit-transition:opacity 1s,max-height 1s;transition:opacity 1s,max-height 1s}.slidedown-enter,.slidedown-leave-to{max-height:0;opacity:0;overflow:hidden}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-68a72026","scoped":false,"hasInlineConfig":true}!./node_modules/sass-loader/lib/loader.js?indentedSyntax!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./sportspower/assets/es6/components/Fader.vue
// module id = 46
// module chunks = 0